import * as React from "react";
import type { SVGProps } from "react";
const SvgSkiLiftCabin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.5 6.35a1.01 1.01 0 0 0 1.29.59l2.65-.993V9.01H7.75c-.96 0-1.88.7-2.13 1.63-.83 3.18-.83 6.55 0 9.74.25.92 1.16 1.62 2.13 1.62h9.38c.95 0 1.88-.71 2.13-1.63.83-3.18.83-6.55 0-9.74-.24-.92-1.16-1.62-2.13-1.62h-3.69V5.198L16.8 3.94c.51-.2.77-.77.58-1.29-.2-.52-.77-.78-1.29-.59l-8.01 3c-.51.2-.77.77-.58 1.29M11.44 20v-2H7.184q.136.943.376 1.87c.02.04.14.13.2.13zm-4.428-4h4.428v-5H7.76c-.06 0-.18.09-.2.15A17.4 17.4 0 0 0 7.012 16m6.428 4v-2h4.264q-.135.935-.374 1.85c-.02.06-.14.15-.2.15zm0-4h4.438a17.5 17.5 0 0 0-.548-4.87c-.02-.04-.14-.13-.2-.13h-3.69z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSkiLiftCabin;
